<template>
  <div class="ap-field">
    <label>{{ label }} <span v-if="required" class="ap-req">*</span></label>
    <div class="ap-input-wrap">
      <fa-icon v-if="icon" :icon="icon" class="ap-lead" />
      <input
        :value="value"
        :type="type"
        :placeholder="placeholder"
        :autocomplete="autocomplete"
        class="ap-input"
        @input="onInput($event)"
      />
    </div>
    <span v-if="hint" class="ap-hint">{{ hint }}</span>
  </div>
</template>

<script>
export default {
  name: 'TextInput',
  props: {
    value: { type: String, default: '' },
    label: { type: String, default: '' },
    icon: { type: Array, default: null },
    placeholder: { type: String, default: '' },
    required: { type: Boolean, default: false },
    type: { type: String, default: 'text' },
    hint: { type: String, default: '' },
    autocomplete: { type: String, default: undefined },
    uppercase: { type: Boolean, default: false }
  },
  methods: {
    onInput (e) {
      const val = this.uppercase ? e.target.value.toUpperCase() : e.target.value
      if (this.uppercase) e.target.value = val
      this.$emit('input', val)
    }
  }
}
</script>
